export default __webpack_public_path__ + "static/media/pics1.c4a8e171.png";